import { useEffect } from 'react';
import { Col, FormGroup, Input } from 'reactstrap';
import { Controller } from 'react-hook-form';
import flightIcon from '../../../assets/images/travel-request/flight.png';
import hotelIcon from '../../../assets/images/travel-request/hotel.png';
import airportIcon from '../../../assets/images/travel-request/airport.png';
import insuranceIcon from '../../../assets/images/travel-request/insurance.png';
import visaIcon from '../../../assets/images/travel-request/visa.png';

function Requirements({
  isEdit,
  isView = false,
  detailsData,
  control,
  watch,
  setValue,
}) {
  const headerDetails = detailsData?.headerDetails;

  const requirements = watch('requirements');

  const items = [
    {
      attribute: 'flight',
      name: 'requirements.flight',
      label: 'Flight',
      icon: flightIcon,
    },
    {
      attribute: 'hotel',
      name: 'requirements.hotel',
      label: 'Hotel',
      icon: hotelIcon,
    },
    {
      attribute: 'airport',
      name: 'requirements.airport',
      label: 'Airport Transfer',
      icon: airportIcon,
    },
    {
      attribute: 'insurance',
      name: 'requirements.insurance',
      label: 'Travel Insurance',
      icon: insuranceIcon,
    },
    {
      attribute: 'visa',
      name: 'requirements.visa',
      label: 'Visa',
      icon: visaIcon,
    },
  ];

  useEffect(() => {
    if (isEdit && headerDetails) {
      setValue('requirements', {
        flight: headerDetails?.Flight === 'Y',
        hotel: headerDetails?.Hotel === 'Y',
        airport: headerDetails?.AirportTransfer === 'Y',
        insurance: headerDetails?.TravelInsurance === 'Y',
        visa: headerDetails?.Visa === 'Y',
      });
    }
  }, [isEdit, headerDetails, setValue]);

  const onCheck = field => {
    if (!isView) {
      field.onChange(!field.value);
    }
  };

  return (
    <div className="new-travel-request-card p-3 bg-white">
      <div className="fw-semibold mb-2 fs-5">Requirements</div>
      <div className="d-flex flex-row justify-content-between gap-3">
        {items?.map((item, index) => (
          <Col key={index}>
            <Controller
              name={item?.name}
              control={control}
              defaultValue={false}
              render={({ field }) => (
                <div
                  htmlFor={item?.attribute}
                  onClick={() => onCheck(field)}
                  className={`ntr-requirements clickable-requirement cursor-pointer ${requirements?.[item?.attribute] && 'ntr-requirements-selected'}`}
                >
                  <FormGroup
                    check
                    className="d-flex align-items-center gap-2 mb-0"
                  >
                    <Input
                      type="checkbox"
                      className="form-check-input blue-checkbox"
                      id={item?.attribute}
                      {...field}
                      checked={field.value}
                      disabled={isView}
                    />
                    <div className="d-flex align-items-center gap-2">
                      <img src={item?.icon} alt={`${item?.label} Icon`} />
                      <span className="fw-semibold fs-5">{item?.label}</span>
                    </div>
                  </FormGroup>
                </div>
              )}
            />
          </Col>
        ))}
      </div>
    </div>
  );
}

export default Requirements;
